export const ENDPOINT = "https://api.humanatlas.top"
export const TILES_URL = "https://tiles.humanatlas.top"